import {
    Box,
    Center,
    Grid,
    GridItem,
    Heading,
    Image,
    SimpleGrid,
    Stack,
    Text,
    Wrap,
    WrapItem
} from '@chakra-ui/react';
import { CheckboxContainer } from 'formik-chakra-ui';
import { useState } from 'react';
import CloseIcon from '../../../assets/icons/Icon.svg';
import CreateProfileButton from '../CreateProfileButton';
import FormNavigation from '../FormNavigation';
import { FormStep } from '../MultiStepForm';

export default function Careers(props: {
    choices: any;
    setChoices: any;
    onSubmit: any;
    formError: any;
    hasOwnNavigation: boolean;
    validationSchema: any;
}) {
    const { choices, setChoices, onSubmit, formError, validationSchema } = props;
    const [checkBoxDisabled, setCheckBoxDisabled] = useState(false);
    const handleCheckboxChange = (e: any) => {
        let choiceCopy = [...choices];
        if (choiceCopy.length < 5) {
            if (choiceCopy.includes('')) {
                choiceCopy.pop();
            }
            if (choiceCopy.includes(e.target.value)) {
                choiceCopy.splice(choiceCopy.indexOf(e.target.value), 1);
                setChoices([...choiceCopy]);
            } else setChoices([...choiceCopy, e.target.value]);
        } else {
            if (choiceCopy.includes(e.target.value)) {
                choiceCopy.splice(choiceCopy.indexOf(e.target.value), 1);
                setChoices([...choiceCopy]);
            }
        }
    };
    const businessFinanceCareers: string[] = [
        'Accounting',
        'Account Management',
        'Corporate Finance',
        'Investment Banking',
        'Business Intelligence Analytics',
        'Financial Analysis',
        'Management Consulting',
        'Business Analysis',
        'Organizational Development',
        'Project Management',
        'Sales Operations',
        'Technology Sales'
    ];

    const peopleAndCommunityCareers: string[] = [
        'Talent Acquisition',
        'Community Management',
        'Learning & Development',
        'Customer Success',
        'People Analytics',
        'People Operations',
        'Recruiting'
    ];

    const marketingCareers: string[] = [
        'Brand Marketing',
        'Digital Marketing',
        'Email Marketing',
        'Event Marketing',
        'Paid Search Marketing',
        'Partnership Marketing',
        'Product Marketing',
        'Field Marketing',
        'Search Engine Optimization',
        'Social Media Marketing'
    ];

    const productAndDesignCareers: string[] = [
        'Product Design',
        'Product Management',
        'User Experience (UX) Design',
        'User Interface (UI) Design',
        'Product Marketing'
    ];

    const computersAndEngineeringCareers: string[] = [
        'Software Engineering',
        'Android Development',
        'Data Analysis',
        'Data Engineering',
        'Data Science',
        'DevOps Engineering',
        'Mechanical Engineering',
        'iOS Development'
    ];
    const businessFinanceColumn = businessFinanceCareers.map(function (career) {
        return (
            <CreateProfileButton
                type="careers"
                name="careers"
                text={career}
                key={career}
                onChange={handleCheckboxChange}
                isChecked={choices.includes(career)}
                isDisabled={choices.length >= 5 && !choices.includes(career)}
            />
        );
    });

    const peopleAndCommunityColumn = peopleAndCommunityCareers.map(function (career) {
        return (
            <CreateProfileButton
                type="careers"
                name="careers"
                text={career}
                key={career}
                onChange={handleCheckboxChange}
                isChecked={choices.includes(career)}
                isDisabled={choices.length >= 5 && !choices.includes(career)}
            />
        );
    });

    const marketingColumn = marketingCareers.map(function (career) {
        return (
            <CreateProfileButton
                type="careers"
                name="careers"
                text={career}
                key={career}
                onChange={handleCheckboxChange}
                isChecked={choices.includes(career)}
                isDisabled={choices.length >= 5 && !choices.includes(career)}
            />
        );
    });

    const productAndDesignColumn = productAndDesignCareers.map(function (career) {
        return (
            <CreateProfileButton
                type="careers"
                name="careers"
                text={career}
                key={career}
                onChange={handleCheckboxChange}
                isChecked={choices.includes(career)}
                isDisabled={choices.length >= 5 && !choices.includes(career)}
            />
        );
    });

    const computersAndEngineeringColumn = computersAndEngineeringCareers.map(function (career) {
        return (
            <CreateProfileButton
                type="careers"
                name="careers"
                text={career}
                key={career}
                onChange={handleCheckboxChange}
                isChecked={choices.includes(career)}
                isDisabled={choices.length >= 5 && !choices.includes(career)}
            />
        );
    });
    
    const handleCloseIconClick = (career: string) => {
      const choicesCopy = [...choices];
      choicesCopy.splice(choicesCopy.indexOf(career), 1);
      setChoices([...choicesCopy]);
      setCheckBoxDisabled(false);
    };

    const yourCareerChoices = choices.map((choice: string) => {
        if (choices.includes('')) {
            choices.pop();
        }
        return (
            <WrapItem
                value={choice}
                key={choice}
                w="fit-content"
                fontSize="13px"
                border="1px solid black"
                bg="#FFFFFF"
                borderRadius="100px"
                padding="3px 6px"
                justify="center"
            >
                <Center lineHeight="16px" fontWeight={600}>
                    {choice}

                    <Image
                        _hover={{
                            cursor: 'pointer'
                        }}
                        mt="2px"
                        ml="2px"
                        src={CloseIcon}
                        w="12px"
                        h="14px"
                        onClick={() => handleCloseIconClick(choice)}
                    ></Image>
                </Center>
            </WrapItem>
        );
    });

    return (
        <FormStep
            stepName="careers"
            onSubmit={onSubmit}
            formError={formError}
            validationSchema={validationSchema}
        >
            <Center>
                <Box w="786px" h="1600px">
                    <Stack>
                        <Heading fontSize="32px" fontWeight={800}>
                            What careers are you interested in?
                        </Heading>
                        <Text fontWeight={400} fontSize="15px" color="#686672">
                            Select 1–5 choices
                        </Text>
                        <Box>
                            
                                <CheckboxContainer name="careers" h="48px" ml='-4'>
                                <SimpleGrid
                                columns={2}
                                spacingX="38px"
                                spacingY={3}
                                mb={24}
                                h="100%"
                                alignSelf="center"
                            >
                                    <Box align="right">
                                        <Text
                                            align="left"
                                            fontWeight={800}
                                            fontSize="20px"
                                            lineHeight="28px"
                                            w="350px"
                                        >
                                            Business & Finance
                                        </Text>
                                        {businessFinanceColumn}
                                        <Text
                                            align="left"
                                            fontWeight={800}
                                            fontSize="20px"
                                            lineHeight="28px"
                                            mt="36px"
                                            w="350px"
                                        >
                                            People & Community
                                        </Text>
                                        {peopleAndCommunityColumn}
                                    </Box>
                                    <Box align="left">
                                        <Text
                                            align="left"
                                            fontWeight={800}
                                            fontSize="20px"
                                            lineHeight="28px"
                                            w="350px"
                                        >
                                            Marketing
                                        </Text>
                                        {marketingColumn}
                                        <Text
                                            align="left"
                                            fontWeight={800}
                                            fontSize="20px"
                                            lineHeight="28px"
                                            mt="36px"
                                            w="350px"
                                        >
                                            Product & Design
                                        </Text>
                                        {productAndDesignColumn}
                                        <Text
                                            align="left"
                                            fontWeight={800}
                                            fontSize="20px"
                                            lineHeight="28px"
                                            mt="36px"
                                            w="350px"
                                        >
                                            Computers & Engineering
                                        </Text>
                                        {computersAndEngineeringColumn}
                                    </Box>
                                </SimpleGrid>
                                </CheckboxContainer>
                            
                        </Box>
                    </Stack>
                </Box>
            </Center>
            <Center>
                <Box
                    alignSelf="center"
                    bg="#F9F5FF"
                    w="740px"
                    h="232px"
                    borderRadius="28px"
                    mb="12px"
                >
                    <Grid
                        h="200px"
                        templateRows="repeat(3, 1fr)"
                        templateColumns="repeat(3, 1fr)"
                        gap={1}
                    >
                        <GridItem align="center" rowSpan={1} colSpan={1} />
                        <GridItem  rowSpan={1}>
                            <Center fontWeight={600} mt="28px">
                                Your chioices:
                            </Center>
                        </GridItem>
                        <GridItem colSpan={1} />
                        <GridItem colSpan={3} display="flex" justifyContent="space-around">
                            <Wrap mb="12px" mt="24px" justify="center" w="600px" h="50px">
                                {yourCareerChoices}
                            </Wrap>
                        </GridItem>
                        <GridItem align="center" colSpan={3} rowSpan={1}>
                            <FormNavigation
                                isLastStep={false}
                                hasPrevious={true}
                                buttonWidth={'350px'}
                                hasSkipButton={false}
                                skipbuttonText={'Skip'}
                            />
                        </GridItem>
                    </Grid>
                </Box>
            </Center>
        </FormStep>
    );
}
